<template>
    <section class="home-page__07">
        <img class="title" src="../../assets/images/home/page07/title.png" alt="title">

        <!-- <router-link to="/pre_registration" class="comingsoon">
            <img src="../../assets/images/home/page07/Coming_soon.png" alt="">
        </router-link> -->
        <div class="download-wrap">
            <img src="../../assets/images/home/page07/spec-dl.png" class="download-wrap-img" alt="">
            <div class="download-a-box">
                <a href="https://apps.apple.com/jp/app/epic-seven/id1322399438" target="_blank" class="download-a--ios"></a>
                <a href="https://play.google.com/store/apps/details?id=com.stove.epic7.google" target="_blank" class="download-a--android"></a>
            </div>
        </div>
        
        <img src="../../assets/images/home/page07/basic_information.png" class="information" alt="">

        <div class="copy-wrap">
            <img src="../../assets/images/home/page07/logo.png" class="logo" alt="">
            <img src="../../assets/images/home/page07/Copyright_notation.png" class="copyright" alt="">
            <P class="company-info">
                <router-link to="/policy" class="info-a">利用規約</router-link>
                <router-link to="/privacy_policy" class="info-a">プライバシーポリシー</router-link>
                <router-link to="/money_settlement" class="info-a">資金決済法に基づく表示</router-link>
                <router-link to="/specific_business" class="info-a">特定商取引法に基づく表示</router-link>
            </P>
        </div>
    </section>
</template>

<script>
export default {
    name: "home-page07",

    components: {

    },
    data: () => ({
    }),
    created() {

    },
    mounted() {

    },
    watch: {

    },
    computed: {

    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
.home-page__07 {
    overflow: hidden;
    position: relative;
    background: url("../../assets/images/home/page07/bg.png") no-repeat center;
    background-size: cover;

    .title {
        position: absolute;
        z-index: 3;
        height: 100%;
        left: pxTorem(27px);
        opacity: 0.8;
    }

    .download-wrap {
        position: absolute;
        width: pxTorem(673px);
        left: 50%;
        top: 15%;
        transform: translateX(-50%);

        .download-wrap-img {
            width: 100%;
        }
        .download-a-box {
            position: absolute;
            width: 83%;
            height: 23%;
            bottom: 23%;
            left: 50%;
            transform: translateX(-50%);
            display: flex;

            a {
                flex: 1;
                display: block;

                &:first-of-type {
                    margin-right: pxTorem(30px);
                }
            }
        }
    }

    .comingsoon {
        position: absolute;
        width: pxTorem(800px);
        left: 50%;
        top: 25%;
        transform: translateX(-50%);

        img {
            width: 100%;
        }
    }

    .information {
        position: absolute;
        width: pxTorem(800px);
        left: 50%;
        bottom: 20%;
        transform: translateX(-50%);
    }

    .copy-wrap {
        width: pxTorem(400px);
        position: absolute;
        left: 50%;
        bottom: 5%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .logo {
            width: 60%;
            margin-bottom: pxTorem(20px);
        }
        .copyright {
            width: 180%;
        }
        .company-info {
            font-size: pxTorem(16px);
            white-space: nowrap;
            margin-top: pxTorem(10px);
            
            .info-a {
                color: #eee;

                &:not(:last-child)::after {
                    content: "/";
                    margin: 0 5px;
                }
            }
        }
    }
}
</style>
